<script>
import { IsNullOrEmpty } from "@/modules/helper/index";
import * as Helper from '@/modules/helper/index'
import { mapGetters } from "vuex";
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    required: {
        type: Boolean,
        default: false
    },
    value: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data() {
    return {      
      rating: 3,
      mouseOver: null
    }
  },
  computed: {
    ...mapGetters([
      'AppConfig'
      // ImageRating,
      // StarRating
    ]),
    AppThemeColor() {
      return Helper.HashCodeFromInt(this.AppConfig.DesignSettings.AppThemeColor)
    },
    AppThemeFontColor() {
      return Helper.HashCodeFromInt(this.AppConfig.DesignSettings.AppThemeFontColor)
    },
    IsNullOrEmptyErrorMessage() {
        if (this.required && !IsNullOrEmpty(this.value)) {
          return true
        }
    }
  },
  methods: {
    setRating(rating) {
      this.$emit('propChange', { value: rating.toString() })
      this.rating= rating;
    }
  },
};
</script>
<template>
  <f7-list class="inputs-list">
    <div class="ratingdiv" >
      <f7-label class="label-color">{{label}}</f7-label>
            <star-rating 
            @rating-selected ="setRating"
            :item-size="30"
            :show-rating="false"
             v-bind:increment="1"
             v-bind:max-rating="5"
             :inactive-color="AppThemeFontColor"
             :active-color="AppThemeColor"
             :border-color="AppThemeColor"
            ></star-rating>
            <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
            </div>
    </f7-list>
</template>
<style scoped>
  .ratingdiv {
    padding: 5px 10px;
  }
  .list {
    margin: 15px 0;
  }
  .item-label {
  padding-bottom: 5px;
  }
  /* .vue-rate-it-rating >>> .vue-rate-it-rating-item:first-child{
  margin-left: 0px;
  } */
  .vue-rate-it-rating >>> .vue-rate-it-rating-item {
    width: 20%;
    width: calc((100% - 15px*4) / 5);
  }
  .vue-rate-it-rating-container >>> .vue-rate-it-rating {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex!important;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start!important;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/Rating.vue